import React from 'react';
import { getBottomNavListClasses } from './bottomNav.logic.js';
export function BottomNavV3({ children, className, dataMetrics, dataTestId }) {
    return (React.createElement("ul", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'bottom-nav', className: getBottomNavListClasses(className?.list) }, children));
}
//# sourceMappingURL=BottomNavV3.js.map